import React from 'react';
import { MapPin, Phone, ExternalLink, MessageCircle, Mail } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-white border-t border-gray-100 py-16 px-4 sm:px-6 lg:px-8 mt-auto text-gray-800">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-12">

        <div>
          <h3 className="text-2xl font-bold mb-4 tracking-tight text-gray-900">Saim Autos</h3>
          <p className="text-gray-700 text-sm font-medium leading-relaxed max-w-sm">
            Genuine spare parts for CD70 and CG125 in Pakistan. Keeping local bikes on the road with quality components.
          </p>
        </div>

        <div>
          <h4 className="text-lg font-bold mb-4 text-gray-900">Links</h4>
          <ul className="space-y-3 text-sm font-medium text-gray-700">
            <li><Link to="/shop" className="cursor-target hover:text-red-600 transition-colors">Shop All</Link></li>
            <li><Link to="/categories" className="cursor-target hover:text-red-600 transition-colors">Categories</Link></li>
            <li><Link to="/about" className="cursor-target hover:text-red-600 transition-colors">About Us</Link></li>
            <li><Link to="/contact" className="cursor-target hover:text-red-600 transition-colors">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-lg font-bold mb-4 text-gray-900">Contact</h4>
          <ul className="space-y-4 text-sm font-medium text-gray-700">
            <li className="flex flex-col space-y-3">
              <div className="flex items-center space-x-3">
                <Phone size={16} className="text-red-500 shrink-0" />
                <span>+92 3480763291 / +92 3064981434</span>
              </div>
              <div className="flex items-center space-x-3">
                <MessageCircle size={16} className="text-[#25D366] shrink-0" />
                <span>+92 3063580306</span>
              </div>
              <div className="flex items-center space-x-3">
                <Mail size={16} className="text-blue-500 shrink-0" />
                <a href="mailto:contact@saimautos.com" className="hover:text-red-600 transition-colors">contact@saimautos.com</a>
              </div>
            </li>
            <li className="flex items-start space-x-3">
              <MapPin size={18} className="text-red-500 mt-1 shrink-0" />
              <span>Sheikh Fazal Road Gaggu Mandi Burewala, Vehari, Punjab</span>
            </li>
          </ul>
        </div>

      </div>

      <div className="max-w-7xl mx-auto mt-16 pt-8 border-t border-gray-100 text-center text-sm font-medium text-gray-500">
        <p className="mb-4">&copy; {new Date().getFullYear()} Saim Autos All Copyrights Reserved.</p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-gray-400">
          <span>Developed with ❤️ by <a href="https://devbazm.vercel.app/" target="_blank" rel="noopener noreferrer" className="text-red-500 hover:text-red-600 transition-colors">DevBazm</a></span>
          <span className="hidden sm:inline opacity-30">|</span>
          <a href="https://www.linkedin.com/company/107953805" target="_blank" rel="noopener noreferrer" className="hover:text-blue-500 transition-colors flex items-center gap-1">
            <ExternalLink size={16} /> Official LinkedIn
          </a>
        </div>
      </div>
    </footer>
  );
}
